var localcachingArray = [];

export function setCache(key, value) {
  localcachingArray[key] = value;
}

export function getCache(key) {
  return localcachingArray[key];
}

export function getDateFormat(date, format, seperator = "-") {
  var arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  if (date == undefined || date == null || date == "") return "";
  var mArr = date.split("T");
  var dateStr = mArr[0];
  if (format == "yyyy-mm-dd")
    return dateStr;
  else if (format == "dd-mmm-yyyy") {
    var dArr = dateStr.split(seperator);
    if (arr.includes(dArr[1])) {
      if (dArr[2].length == 4) {
        return dArr[0] + "-" + dArr[1] + "-" + dArr[2];
      }
      else if (dArr[0].length == 4) {
        return dArr[2] + "-" + dArr[1] + "-" + dArr[0];
      }
      else {
        return dArr[2] + "-" + dArr[1] + "-" + dArr[0];
      }

    }
    else {
      if (dArr[2].length == 4) {
        return dArr[0] + "-" + getShortMonthName(parseInt(dArr[1])) + "-" + dArr[2];
      }
      else if (dArr[0].length == 4) {
        return dArr[2] + "-" + getShortMonthName(parseInt(dArr[1])) + "-" + dArr[0];
      }
      else {
        return dArr[2] + "-" + getShortMonthName(parseInt(dArr[1])) + "-" + dArr[1];
      }
    }
  } else if (format == "mmm-yyyy") {
    var dArr = dateStr.split(seperator);
    if (dArr[2].length == 4) {
      return getShortMonthName(parseInt(dArr[1])) + "-" + dArr[2].slice(-2);
    }
    else if (dArr[0].length == 4) {
      return getShortMonthName(parseInt(dArr[1])) + "-" + dArr[0].slice(-2);
    }
    else {
      return getShortMonthName(parseInt(dArr[1])) + "-" + dArr[0].slice(-2);
    }
  }
  return dateStr;

}
export function getShortMonthName(month) {
  var arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  month = parseInt(month, 10);
  var intmonth;
  for (intmonth = 0; intmonth < arr.length; intmonth++) {
    if (intmonth + 1 === month) {
      return arr[intmonth];
    }
  }
}
